module.exports = __webpack_public_path__ + "img/buy_normal_zh.b841e019.png";